import { MouseSensor as MouseSensor$1 } from '@dnd-kit/core';

const PREVENT_DND_PROP_FIELD = "data-no-dnd";
const PREVENT_DND_PROP_DOM_STRING_MAP = "noDnd";
const handler = ({ nativeEvent: event }) => {
  let cur = event.target;
  while (cur) {
    if (cur.dataset && cur.dataset[PREVENT_DND_PROP_DOM_STRING_MAP]) {
      return false;
    }
    cur = cur.parentElement;
  }
  return true;
};
function preventDndProps() {
  return { [PREVENT_DND_PROP_FIELD]: "true" };
}
class MouseSensor extends MouseSensor$1 {
}
MouseSensor.activators = [
  { eventName: "onMouseDown", handler }
];

export { MouseSensor, preventDndProps };
//# sourceMappingURL=sensor.mjs.map
